import { Component, Input } from "@angular/core";

@Component({
    selector: 'tyt-offer-tier',
    templateUrl: `./offer-tier.component.html`,
    styleUrls: [`./offer-tier.component.scss`]
})
export class OfferTierComponent {
    @Input() label : string;
    @Input() summary : string;
    @Input() tooltip : string;
}